import React from 'react';
import Login from '../pages/auth/login';
import ForgotPassword from '../pages/auth/forgot-password';
import ResetPassword from '../pages/auth/reset-password';
import NotFound from '../pages/errors/404';
import Dashboard from '../pages/dashboard';
import {useAuth} from '../context/auth';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import AuthRoute from "./auth-route";
import GuestRoute from "./guest-route";
import InitialLoading from "../components/initial-loading";
import Profile from "../pages/user/profile";
import BaseError from "../pages/errors/base-error";
import UsersList from "../pages/user/users-list";
import RolesList from "../pages/permissions/roles-list";
import UserDetail from "../pages/user/user-detail";
import {AppRoutes} from "../utils/constants";
import UserGroupsList from "../pages/user-groups/user-groups-list";
import RepresentativesList from "../pages/user/representatives-list";
import BuildingsList from "../pages/building/buildings-list";
import ManagersList from "../pages/building/managers-list";
import BuildingsPortfolio from "../pages/building/buildings-portfolio";
import BuildingPortfolioDetail from "../pages/building/building-portfolio-detail";
import ArticleDetail from "../pages/articles/article-detail";
import ArticlesList from "../pages/articles/articles-list";
import BuildingStatsList from "../pages/building/building-stats-list";
import BuildingStatTypesList from "../pages/building/building-stat-types-list";
import AttachmentCategoriesList from "../pages/attachment/attachment-categories-list";
import MembershipSharesList from "../pages/membership-shares/membership-shares-list";
import TransactionsList from "../pages/transactions/transactions-list";
import InternalValuesList from "../pages/internal-values/internal-values-list";
import Membership from "../pages/membership/membership";
import MembershipDocumentsList from "../pages/membership/membership-documents-list";
import MembershipGalleryList from "../pages/membership/membership-gallery-list";

export default function App () {
  let { initializing } = useAuth();

  const router = createBrowserRouter([
    {
      path: AppRoutes.landing.path,
      errorElement: <BaseError />,
      children: [
        {
          path: '',
          element: <GuestRoute component={Login} />
        },
        {
          path: AppRoutes.login.path.substring(1),
          element: <GuestRoute component={Login} />
        },
        {
          path: AppRoutes.passwordRecovery.path.substring(1),
          element: <GuestRoute component={ForgotPassword} />
        },
        {
          path: AppRoutes.passwordChange.path.substring(1),
          element: <GuestRoute component={ResetPassword} />
        },
        {
          path: AppRoutes.home.path.substring(1),
          element: <AuthRoute component={Dashboard} />
        },
        {
          path: AppRoutes.profile.path.substring(1),
          element: <AuthRoute component={Profile} />
        },
        {
          path: AppRoutes.users.path.substring(1),
          children: [
            {
              path: '',
              element: <AuthRoute component={UsersList} />
            },
            {
              path: ":id",
              element: <AuthRoute component={UserDetail} />
            },
          ]
        },
        {
          path: AppRoutes.buildingsPortfolio.path.substring(1),
          children: [
            {
              path: '',
              element: <AuthRoute component={BuildingsPortfolio} />
            },
            {
              path: ":id",
              element: <AuthRoute component={BuildingPortfolioDetail} />
            },
          ]
        },
        {
          path: AppRoutes.articles.path.substring(1),
          children: [
            {
              path: '',
              element: <AuthRoute component={ArticlesList} />
            },
            {
              path: ":id",
              element: <AuthRoute component={ArticleDetail} />
            },
          ]
        },
        {
          path: AppRoutes.roles.path.substring(1),
          element: <AuthRoute component={RolesList} />
        },
        {
          path: AppRoutes.userGroups.path.substring(1),
          element: <AuthRoute component={UserGroupsList} />
        },
        {
          path: AppRoutes.representatives.path.substring(1),
          element: <AuthRoute component={RepresentativesList} />
        },
        {
          path: AppRoutes.buildings.path.substring(1),
          element: <AuthRoute component={BuildingsList} />
        },
        {
          path: AppRoutes.managers.path.substring(1),
          element: <AuthRoute component={ManagersList} />
        },
        {
          path: AppRoutes.buildingStatTypes.path.substring(1),
          element: <AuthRoute component={BuildingStatTypesList} />
        },
        {
          path: AppRoutes.internalValues.path.substring(1),
          element: <AuthRoute component={InternalValuesList} />
        },
        {
          path: AppRoutes.membershipShares.path.substring(1),
          element: <AuthRoute component={MembershipSharesList} />
        },
        {
          path: AppRoutes.transactions.path.substring(1),
          element: <AuthRoute component={TransactionsList} />
        },
        {
          path: AppRoutes.attachmentCategories.path.substring(1),
          children: [
            {
              path: '',
              element: <AuthRoute component={AttachmentCategoriesList} />
            },
            {
              path: ":tab",
              element: <AuthRoute component={AttachmentCategoriesList} />
            },
          ]
        },
        {
          path: AppRoutes.buildingStats.path.substring(1),
          children: [
            {
              path: '',
              element: <AuthRoute component={BuildingStatsList} />
            },
            {
              path: ":building",
              element: <AuthRoute component={BuildingStatsList} />
            },
          ]
        },
        {
          path: AppRoutes.membership.path.substring(1),
          element: <AuthRoute component={Membership} />
        },
        {
          path: AppRoutes.membershipDocuments.path.substring(1),
          element: <AuthRoute component={MembershipDocumentsList} />
        },
        {
          path: AppRoutes.membershipGallery.path.substring(1),
          element: <AuthRoute component={MembershipGalleryList} />
        },
      ]
    },
    {
      path: '*',
      element: <NotFound />,
      errorElement: <BaseError />
    },
  ]);

  return (
    initializing ? <InitialLoading /> : <RouterProvider router={router} />
  );
}
